import { addDoc, collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../../../firebase";
import { STUDIO_RELEASE_ERRORS_COLLECTION } from "../../constants";

const LOCAL_ERRORS_KEY = "firestoreStudio.release.errors";

function nowIso() {
  return new Date().toISOString();
}

function generateErrorId() {
  return `ERR-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`.toUpperCase();
}

export function reportError({ message, stack, source = "frontend", meta = {} }) {
  const entry = {
    errorId: generateErrorId(),
    message: message || "Unknown error",
    stack: stack || "",
    source,
    meta,
    createdAt: nowIso(),
  };

  try {
    const stored = JSON.parse(localStorage.getItem(LOCAL_ERRORS_KEY) || "[]");
    stored.unshift(entry);
    localStorage.setItem(LOCAL_ERRORS_KEY, JSON.stringify(stored.slice(0, 100)));
  } catch { /* ignore */ }

  addDoc(collection(db, STUDIO_RELEASE_ERRORS_COLLECTION), entry).catch(() => {});

  return entry;
}

export async function listReportedErrors(max = 100) {
  const local = [];
  try {
    local.push(...JSON.parse(localStorage.getItem(LOCAL_ERRORS_KEY) || "[]"));
  } catch { /* ignore */ }

  try {
    const snap = await getDocs(
      query(collection(db, STUDIO_RELEASE_ERRORS_COLLECTION), orderBy("createdAt", "desc"), limit(max))
    );
    const remote = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    const merged = [...local, ...remote];
    const seen = new Set();
    return merged.filter((e) => {
      const key = e.errorId || e.id;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    }).slice(0, max);
  } catch {
    return local.slice(0, max);
  }
}

export { generateErrorId };
